import { ReactNode } from "react";

type BenefitCardProps = {
  icon: ReactNode;
  title: string;
  description: string;
};

export default function BenefitCard({
  icon,
  title,
  description,
}: BenefitCardProps) {
  return (
    <div className="rounded-xl border border-neutral-10 bg-constant-white p-3 sm:rounded-2xl sm:p-4 lg:p-6">
      <div className="mb-2 flex gap-2 items-center">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg border border-neutral-10 bg-blue-5 sm:h-10 sm:w-10 sm:rounded-xl">
          {icon}
        </div>
        <h3 className="min-w-0 flex-1 text-body-16 font-bold leading-tight text-text-primary sm:text-body-20">
          {title}
        </h3>
      </div>
      <p className="text-body-12-mobile font-medium leading-relaxed text-text-secondary sm:text-body-14-mobile lg:text-body-16">
        {description}
      </p>
    </div>
  );
}
